import SHUserDialog from './src/dialog.vue';

/* istanbul ignore next */
SHUserDialog.install = function(Vue) {
  Vue.component('sh-user-dialog', SHUserDialog);
};

export default SHUserDialog;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/user/dialog/index.js